<template>
  <v-dialog
    max-width="500px"
    scrollable
    v-model="openAddFilter"
    persistent
    :fullscreen="smallScreen"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" text>
        Add Filter
        <v-icon>mdi-filter-plus-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="#f5f5f559" flat>
          <v-toolbar-title>Add Filters</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-row justify="end" no-gutters>
            <v-col cols="12" sm="10" xl="8">
              <v-text-field
                placeholder="search"
                color="primary"
                append-icon="mdi-magnify"
                dense
                outlined
                hide-details
                class="screener-input"
                v-model="searchTxt"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <template
            v-slot:extension
            v-if="!(searchTxt && searchTxt.length > 1)"
          >
            <v-tabs v-model="tab" align-with-title centered fixed show-arrows>
              <v-tab v-for="subhead in subheads" :key="subhead.name">
                {{ subhead.name }}
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text v-if="searchTxt && searchTxt.length > 1" class="filter-res">
        <div class="font-weight-bold pt-4 px-1">Search Results</div>
        <v-checkbox
          dense
          multiple
          :label="f.name"
          color="primary"
          v-model="selected"
          :value="f.refId"
          v-for="f in searchedFilters"
          :key="f.refId"
          :hint="f.description"
          @click="toggleFilter(f)"
          persistent-hint
          readonly
        >
          <template v-slot:append v-if="f.lock">
            <v-icon color="primary" left>mdi-lock-outline</v-icon>
          </template>
        </v-checkbox>
        <!--  -->
        <div
          v-show="!searchedFilters.length"
          class="pt-5 font-weight-bold text-center"
        >
          No filter option found
          <br />
          <span @click="searchTxt = null">
            <a> Clear </a>
          </span>
        </div>
      </v-card-text>
      <v-card-text class="filter-res" v-else>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="subhead in subheads" :key="subhead.refId">
            <v-card flat>
              <v-card-text>
                <v-checkbox
                  dense
                  multiple
                  :label="f.name"
                  color="primary"
                  v-model="selected"
                  :value="f.refId"
                  v-for="f in subhead.filters"
                  :key="f.refId"
                  @click="toggleFilter(f)"
                  :hint="f.description"
                  persistent-hint
                  readonly
                >
                  <template v-slot:append v-if="f.lock">
                    <v-icon color="primary" left>mdi-lock-outline</v-icon>
                  </template>
                </v-checkbox>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pr-4">
        <v-spacer></v-spacer>
        <v-btn outlined text small color="error" @click="openAddFilter = false"
          >close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.filter-res {
  min-height: 250px;
}

.filter-res .v-messages__message {
  margin-left: 32px !important;
  line-height: 16px !important;
}
</style>

<script>
export default {
  name: "addFilter",
  props: {
    selectedFilters: { type: Array, required: true },
  },
  data: () => ({
    ogs: [],
    openAddFilter: false,
    searchTxt: "",
    tab: null,
  }),
  methods: {
    toggleFilter(f) {
      if (f.lock) {
        this.$root.$subscribe.open();
        return;
      }
      this.$emit("toggleFilter", { id: f.refId, lock: f.lock });
    },
  },
  computed: {
    subheads() {
      return this.$store.getters.subheads;
    },
    selected: {
      get() {
        return this.selectedFilters;
      },
      set() {},
    },
    smallScreen() {
      return this.$vuetify.breakpoint.xs;
    },
    searchedFilters() {
      let filters = [];
      if (!this.searchTxt) return filters;
      let searchTxt = this.searchTxt.toUpperCase();
      if (searchTxt.length > 1) {
        for (const key in this.subheads) {
          this.subheads[key].filters.forEach((f) => {
            if (f.name.toUpperCase().indexOf(searchTxt) > -1) {
              filters.push(f);
            }
          });
        }
      }
      return filters;
    },
  },
  created() {
    this.selected = this.selectedFilters;
  },
};
</script>